import { render, staticRenderFns } from "./addSpecialityData.vue?vue&type=template&id=571395ed"
import script from "./addSpecialityData.vue?vue&type=script&lang=js"
export * from "./addSpecialityData.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports